import { createStore } from 'vuex'
import { store as app } from '@/store/modules/app'
import { store as connectivity } from '@/store/modules/connectivity'
import { store as customer } from '@/store/modules/customer'
import { store as lineInfo } from '@/store/modules/lineInfo'
import { store as modalIframe } from '@/store/modules/modalIframe'
import { store as myCouponInfo } from '@/store/modules/myCouponInfo'
import { store as modalTieredPoints } from '@/store/modules/modalTieredPoints'
import { store as modalEditProfile } from '@/store/modules/modalEditProfile'
import { store as modalEditMobile } from '@/store/modules/modalEditMobile'
import { store as modalNotification } from '@/store/modules/modalNotification'
import { store as modalBanner } from '@/store/modules/modalBanner'
import { store as alertMessage } from '@/store/modules/alertMessage'
import { store as coinHistory } from '@/store/modules/coinHistory'
import { store as bannersList } from '@/store/modules/bannersList'
import { store as tier } from '@/store/modules/tier'
import { store as campaignInfo } from '@/store/modules/campaignInfo'
import { RootState } from '@/interfaces/store/root'
import { CustomerStore } from '@/interfaces/store/customer'
import { ConnectivityStore } from '@/interfaces/store/connectivity'
import { LineInfoStore } from '@/interfaces/store/lineInfo'
import { AppStore } from '@/interfaces/store/app'
import { ModalIframeStore } from '@/interfaces/store/modalIframe'
import { MyCouponInfoStore } from '@/interfaces/store/myCouponInfo'
import { ModalEditProfileStore } from '@/interfaces/store/modalEditProfile'
import { ModalEditMobileStore } from '@/interfaces/store/modalEditMobile'
import { ModalNotificationStore } from '@/interfaces/store/modalNotification'
import { ModalBannerStore } from '@/interfaces/store/modalBanner'
import { AlertMessageStore } from '@/interfaces/store/alertMessage'
import { CoinHistoryStore } from '@/interfaces/store/coinHistory'
import { BannersListStore } from '@/interfaces/store/bannersList'
import { TierStore } from '@/interfaces/store/tier'
import { CampaignInfoStore } from '@/interfaces/store/campaignInfo'

export type Store = 
  AppStore<Pick<RootState, 'app'>> &
  CustomerStore<Pick<RootState, 'customer'>> &
  ConnectivityStore<Pick<RootState, 'connectivity'>> &
  LineInfoStore<Pick<RootState, 'lineInfo'>> &
  ModalIframeStore<Pick<RootState, 'modalIframe'>> &
  MyCouponInfoStore<Pick<RootState, 'myCouponInfo'>> &
  ModalEditProfileStore<Pick<RootState, 'modalEditProfile'>> &
  ModalEditMobileStore<Pick<RootState, 'modalEditMobile'>> &
  ModalNotificationStore<Pick<RootState, 'modalNotification'>> &
  ModalBannerStore<Pick<RootState, 'modalBanner'>> &
  AlertMessageStore<Pick<RootState, 'alertMessage'>> &
  CoinHistoryStore<Pick<RootState, 'coinHistory'>> &
  BannersListStore<Pick<RootState, 'bannersList'>> &
  TierStore<Pick<RootState, 'tier'>> &
  CampaignInfoStore<Pick<RootState, 'campaignInfo'>>

export const store = createStore({
  modules: {
    app,
    connectivity,
    customer,
    lineInfo,
    modalIframe,
    modalTieredPoints,
    myCouponInfo,
    modalEditProfile,
    modalEditMobile,
    modalNotification,
    modalBanner,
    alertMessage,
    coinHistory,
    bannersList,
    tier,
    campaignInfo,
  },
})

export function useStore() {
  return store
}

